import { ComponentSync } from '@nu-art/thunderstorm-frontend';
import { compare } from '@nu-art/ts-common';
export class Component_SearchAddOn extends ComponentSync {
    //######################### Life Cycle #########################
    __onSearchFilterChanged() {
        const nextValue = this.props.context.filter.get(this.addOn.key);
        if (!compare(this.state.value, nextValue))
            this.setState({ value: nextValue });
    }
    componentDidMount() {
        this.props.context.filterChangeListeners.register(this);
        this.setState({ value: this.props.context.filter.get(this.addOn.key) });
    }
    componentWillUnmount() {
        this.props.context.filterChangeListeners.unregister(this);
    }
    //######################### Logic #########################
    setValue = (val) => {
        this.props.context.filter.set(this.addOn.key, val);
    };
    clear = () => {
        this.props.context.filter.clear(this.addOn.key);
        this.props.onCleared?.();
    };
}
//# sourceMappingURL=Component_SearchAddOn.js.map